import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _FormattedMessage, _Icon, _Icon2, _Icon3, _Icon4, _Checkbox;

import React, { useState, useEffect, useRef, memo, useMemo } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import Icon from 'components/Icon';
import { Wrapper, SelectButton, SelectLabel, Options, Option, Checkbox, Placeholder, OptionLabel, OptionWrapper, InputWrapper, ClearWrapper, Input, ClearValuesWrapper, PlaceholderValueText, PlaceholderMoreText, IconsWrapper } from './styles';
import { jsx as _jsx2 } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MultiSelect = /*#__PURE__*/memo(function (_ref) {
  var options = _ref.options,
      defaultValues = _ref.defaultValues,
      name = _ref.name,
      placeholder = _ref.placeholder,
      handleValue = _ref.handleValue,
      autocompletePlaceholder = _ref.autocompletePlaceholder,
      label = _ref.label;

  var _useState = useState(defaultValues),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      search = _useState6[0],
      setSearch = _useState6[1];

  var intl = useIntl();
  var wrapperRef = useRef();
  var autoCompleteInputRef = useRef();
  var didMountCurrent = useRef(false);

  var handleDocumentClick = function handleDocumentClick(event) {
    var _wrapperRef$current;

    var targetElement = event.target;

    if (!((_wrapperRef$current = wrapperRef.current) != null && _wrapperRef$current.contains(targetElement)) && wrapperRef.current !== targetElement) {
      setIsOpen(false);
      setSearch(null);
    }
  };

  var handleDropdownClick = function handleDropdownClick(e) {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  var handleChange = function handleChange(value, checked) {
    if (checked) {
      setValues(function (prevState) {
        return prevState.filter(function (item) {
          return item !== value;
        });
      });
    } else {
      setValues(function (prevState) {
        return [].concat(_toConsumableArray(prevState), [value]);
      });
    }
  };

  var isSelectedAll = useMemo(function () {
    return values.length === Object.keys(options).length;
  }, [options, values]);
  var renderPlaceholder = useMemo(function () {
    if (isSelectedAll) {
      return intl.formatMessage({
        id: 'select.all'
      });
    }

    if (values.length > 0) {
      var _options$values$;

      return "".concat((_options$values$ = options[values[0]]) == null ? void 0 : _options$values$.label);
    }

    return placeholder;
  }, [values]);

  var handleSearch = function handleSearch(e) {
    e.preventDefault();
    setSearch(e.target.value);
  };

  var clearSearch = function clearSearch() {
    setSearch(null);
  };

  var clearSelectedValues = function clearSelectedValues() {
    setValues([]);
  };

  useEffect(function () {
    document.addEventListener('click', handleDocumentClick);
    return function () {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);
  useEffect(function () {
    if (autoCompleteInputRef.current) {
      autoCompleteInputRef.current.focus();
    }
  }, [isOpen]);
  useEffect(function () {
    if (didMountCurrent.current) {
      handleValue(_defineProperty({}, name, values));
    } else {
      didMountCurrent.current = true;
    }
  }, [values]);
  useEffect(function () {
    if (values.length && !defaultValues.length) {
      clearSelectedValues();
    }
  }, [defaultValues]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    ref: wrapperRef,
    children: [/*#__PURE__*/_jsx(SelectLabel, {}, void 0, label), /*#__PURE__*/_jsx(SelectButton, {
      onClick: handleDropdownClick
    }, void 0, /*#__PURE__*/_jsx(Placeholder, {}, void 0, /*#__PURE__*/_jsx(PlaceholderValueText, {}, void 0, renderPlaceholder), values.length > 1 && !isSelectedAll && /*#__PURE__*/_jsx(PlaceholderMoreText, {}, void 0, _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      id: "MoreFilters.multiSelect.andMore"
    })), " + ".concat(values.length - 1)), /*#__PURE__*/_jsx(IconsWrapper, {}, void 0, !!values.length && /*#__PURE__*/_jsx(ClearValuesWrapper, {
      onClick: clearSelectedValues
    }, void 0, _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      name: "clear"
    }))), _Icon2 || (_Icon2 = /*#__PURE__*/_jsx(Icon, {
      name: "dropdownArrow"
    }))))), isOpen && /*#__PURE__*/_jsx(Options, {}, void 0, /*#__PURE__*/_jsx(InputWrapper, {
      "data-has-text": !!search
    }, void 0, _Icon3 || (_Icon3 = /*#__PURE__*/_jsx(Icon, {
      name: "search"
    })), /*#__PURE__*/_jsx2(Input, {
      value: search || '',
      ref: autoCompleteInputRef,
      placeholder: autocompletePlaceholder,
      onChange: handleSearch
    }), /*#__PURE__*/_jsx(ClearWrapper, {
      onClick: clearSearch,
      "data-has-search": !!search
    }, void 0, _Icon4 || (_Icon4 = /*#__PURE__*/_jsx(Icon, {
      name: "clear"
    })))), Object.keys(options).map(function (element, index) {
      var option = options[element];
      var isSelected = !!(Array.isArray(values) && values.find(function (item) {
        return item === option.value;
      }));
      var isMatch = search;

      if (isMatch) {
        isMatch = option.label.toLowerCase().includes(search.toLowerCase().trim());

        if (!isMatch) {
          return null;
        }
      }

      return /*#__PURE__*/_jsx(Option, {
        htmlFor: "".concat(name, "-option-").concat(index)
      }, option.value, /*#__PURE__*/_jsx(OptionWrapper, {
        "data-is-checked": isSelected,
        onClick: function onClick() {
          return handleChange(option.value, isSelected);
        }
      }, void 0, _Checkbox || (_Checkbox = /*#__PURE__*/_jsx(Checkbox, {}, void 0, /*#__PURE__*/_jsx(Icon, {
        name: "checked"
      }))), /*#__PURE__*/_jsx(OptionLabel, {
        title: option.label
      }, void 0, option.label)));
    }))]
  });
});
MultiSelect.defaultProps = {
  defaultValues: [],
  autocompletePlaceholder: null
};
export default MultiSelect;